import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import BaraemQuestionHeading from './BaraemQuestionHeading';
import ChildAccordion from './childAccordion';

const BaraemQuestionStep3 = ({
  setQuestionStep,
  questions,
  responses,
  setResponses,
  baraemUsername,
  hcNumber,
  questionnaireid,
  startingIndex,
  stepSummary,
  updateStepSummary,
  questionnaire,
  age,
  translationMap
}) => {
  const navigate = useNavigate();
  const [isFormValid, setIsFormValid] = useState(false);

  const handleResponseChange = (question, answer) => {
    const hasConcern = answer === "Yes" ? 1 : 0;
    setResponses((prev) => {
      const existingResponse = prev[question.id] || {};
      const updatedResponses = {
        ...prev, [question.id]: {
          ...prev[question.id],
          answer,
          answertext: "", // baraemusername,
          hasConcern,
          hcnumber: hcNumber,
          isactive: 1,
          isFeedback: 0,
          isScheduleAppointment: 0,
          questionid: question.id,
          questionnaireid: questionnaireid,
          questiontext: question.question,
          questiontext_i18n: question.question_i18n,
          category: existingResponse.category || "Fine Motor",
          category_i18n: existingResponse.category_i18n || {
            "ar_SA": "مهارات الحركات الدقيقة", "en_US": "Fine Motor"
          }
        }
      };

      const currentSectionQuestions = questions.map((q) => q.id);
      const sectionResponses = Object.values(updatedResponses).filter((resp) => currentSectionQuestions.includes(resp.questionid));

      const numberOfYes = sectionResponses.filter((resp) => resp.answer === "Yes").length;
      const numberOfNo = sectionResponses.filter((resp) => resp.answer === "No").length;
      const isPositiveCase = numberOfYes <= 1 ? 1 : 0;


      updateStepSummary('FineMotor', { numberOfYes, numberOfNo, isPositiveCase });

      return updatedResponses;
    });
  };

  useEffect(() => {
    const currentSectionQuestions = questions.map((q) => q.id);
    const sectionResponses = Object.values(responses).filter((resp) => currentSectionQuestions.includes(resp.questionid));

    const numberOfYes = sectionResponses.filter((resp) => resp.answer === "Yes").length;
    const numberOfNo = sectionResponses.filter((resp) => resp.answer === "No").length;
    const isPositiveCase = numberOfYes <= 1 ? 1 : 0;


    updateStepSummary({ numberOfYes, numberOfNo, isPositiveCase });
    const allAnswered = !questions.some((question) => !responses[question.id]?.answer);
    setIsFormValid(allAnswered);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [responses, updateStepSummary]);
  useEffect(() => {
    window.parent.scrollTo(0, 0);
  }, []);

  const handleContinue = (event) => {
    event.preventDefault();
    if (isFormValid) {
      const formattedResponses = Object.values(responses);
      // console.log('Final Response Format:', formattedResponses);
      setResponses((prevResponses) => {
        const updatedResponses = { ...prevResponses };
        formattedResponses.forEach((resp) => {
          updatedResponses[resp.questionid] = resp;
        });
        return updatedResponses;
      });
      setQuestionStep(4);
    }
  };
  if (!questions || questions.length === 0) {
    return <p>Loading questions...</p>;
  }

  return <div>
            <section className="w-100 clearfix BaraemMainSection" id="CoverPlanActive" style={{
      marginTop: "30px"
    }}>
                <div className="container customContainer">
                    <div className="Title_Inner_Box">
                        <h6 className="MainTitleOne">
                            {translationMap?.childDevAssessment ?? "Child Development Assessment"}
                        </h6>
                    </div>
                    <BaraemQuestionHeading activeStep={3}
        translationMap={translationMap} setQuestionStep={setQuestionStep} />
                    <div className="cover_inner_wrapper">
                        <div className="cover_main_box1">
                            <div className="baraem_main_inner_wrapper">
                                <form className="form_box form_box_mar_top">
                                    <ChildAccordion childName={baraemUsername} age={age}
                ageUnit={translationMap?.months ?? "months"}
                questionnaire={questionnaire} translationMap={translationMap} />

                                    <div className="optimized_welcome_box">
                                        {questions.map((question, index) =>
                  <div className="General_Question_Box" key={question.id}>
                                                <h6 className="question_txt">{`${index + startingIndex} - ${question.question}`}</h6>
                                                <div className="article-question">
                                                    <div className="radio-inline">
                                                        <input
                          className="radio-inline-input"
                          type="radio"
                          name={`inlineRadioOptions${question.id}`}
                          id={`inlineRadioNo${question.id}`}
                          value="No"
                          checked={responses[question.id]?.answer === "No"}
                          onChange={() => handleResponseChange(question, "No")} />
                        
                                                        <label className="radio-inline-label"
                        htmlFor={`inlineRadioNo${question.id}`}>{translationMap?.no ?? "No"}</label>
                                                    </div>
                                                    <div className="radio-inline">
                                                        <input
                          className="radio-inline-input"
                          type="radio"
                          name={`inlineRadioOptions${question.id}`}
                          id={`inlineRadioYes${question.id}`}
                          value="Yes"
                          checked={responses[question.id]?.answer === "Yes"}
                          onChange={() => handleResponseChange(question, "Yes")}
                          required />
                        
                                                        <label className="radio-inline-label"
                        htmlFor={`inlineRadioYes${question.id}`}>{translationMap?.yes ?? "Yes"}</label>
                                                    </div>
                                                </div>
                                            </div>)}
                                    </div>
                                    <div className="Inner_Box">
                                        <div className="form_buton_box">
                      <span>
                        <button type="button" onClick={handleContinue}
                      //         className={
                      //   !isFormValid
                      //     ? "disabled_btn_link"
                      //     : "blue_btn_link"
                      // }
                      className={"step3 " + (!isFormValid ? "disabled_btn_link" : "blue_btn_link")}
                      disabled={!isFormValid}>
                          {translationMap?.continue ?? "Continue"}
                        </button>
                      </span>
                                            <span>
                        <button type="button" onClick={() => setQuestionStep(2)} className="bluetrans_btn_link">
                          {translationMap?.back ?? "Back"}
                        </button>
                      </span>
                                            <span>
                        <button onClick={() => navigate("/")} className="Orangetrans_btn_link">
                          {translationMap?.cancel ?? "Cancel"}
                        </button>
                      </span>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div className="cover_main_box2">

                        </div>
                    </div>
                </div>
            </section>

        </div>;
};

export default BaraemQuestionStep3;